
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 180 180","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"url(#LinearGradient)","stroke-width":"6.25"}},[_c('path',{attrs:{"d":"M101.512 84.189v11.273M113.095 84.189v11.273M123.644 84.189v11.273M104.563 108.647H90.891"}})]),_c('path',{attrs:{"d":"M16.627 90.336c4.136-5.171 12.02-9.108 12.02-9.108a44.57 44.57 0 0118.801-4.132c24.713 0 44.776 20.064 44.776 44.776","fill":"none","stroke":"#323232","stroke-width":"6.25"}}),_c('g',{attrs:{"fill":"none","stroke":"#323232","stroke-width":"6.25"}},[_c('circle',{attrs:{"cx":"47.448","cy":"121.872","r":"14.661"}}),_c('circle',{attrs:{"cx":"47.448","cy":"121.872","r":"31.546"}})]),_c('g',{attrs:{"fill":"none","stroke":"#323232","stroke-width":"6.25"}},[_c('circle',{attrs:{"cx":"140.308","cy":"129.629","r":"23.79"}}),_c('circle',{attrs:{"cx":"140.308","cy":"129.629","r":"11.056"}})]),_c('path',{attrs:{"d":"M28.52 80.809V67.106l7.24-7.239h29.215l8.855 8.855h59.272c10.6 0 10.374 8.144 10.374 10.374v10.783l7.181 7.182v10.15","fill":"none","stroke":"#323232","stroke-width":"6.25"}}),_c('path',{attrs:{"d":"M114.431 68.722V51.34c0-7.757-6.205-6.205-6.205-6.205M117.185 121.872H92.224M37.228 59.867V36.082c0-9.401 9.5-9.501 9.5-9.501h41.584M55.136 26.581v31.078M80.452 27.905L91.893 68","fill":"none","stroke":"#323232","stroke-width":"6.25"}})])
          )
        }
      }
    